// client/src/pages/WatchdogPage.jsx
// Main page for the Watchdog event-driven pipeline.
// Tab layout matching CommandPage: Setup → Dashboard

import React, { useState } from "react";
import WatchdogSetupTab from "../components/watchdog/WatchdogSetupTab";
import WatchdogDashboard from "../components/watchdog/WatchdogDashboard";

const tabs = [
    { key: "setup", label: "⚙️ Setup" },
    { key: "dashboard", label: "📊 Dashboard" },
];

const s = {
    page: {
        minHeight: "100vh",
        background: "linear-gradient(180deg, #0f1219 0%, #0a0d14 100%)",
        color: "#e2e8f0",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    header: {
        padding: "24px 32px",
        borderBottom: "1px solid rgba(139, 92, 246, 0.1)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    headerTitle: {
        fontSize: "20px",
        fontWeight: 800,
        background: "linear-gradient(135deg, #8b5cf6 0%, #06b6d4 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    },
    headerSub: {
        color: "#64748b",
        fontSize: "12px",
        marginTop: "2px",
    },
    tabBar: {
        display: "flex",
        gap: "0",
        padding: "0 32px",
        background: "rgba(0,0,0,0.2)",
        borderBottom: "1px solid rgba(139, 92, 246, 0.08)",
    },
    tab: (active) => ({
        padding: "14px 24px",
        cursor: "pointer",
        fontSize: "13px",
        fontWeight: active ? 700 : 500,
        color: active ? "#8b5cf6" : "#64748b",
        borderBottom: active ? "2px solid #8b5cf6" : "2px solid transparent",
        transition: "all 0.2s ease",
        background: "transparent",
        border: "none",
        borderBottomWidth: "2px",
        borderBottomStyle: "solid",
        borderBottomColor: active ? "#8b5cf6" : "transparent",
    }),
    content: {
        padding: "24px 32px",
        maxWidth: "1200px",
        margin: "0 auto",
    },
    dbStatus: (ok) => ({
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "11px",
        color: ok ? "#10b981" : "#f59e0b",
    }),
    dot: (ok) => ({
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        background: ok ? "#10b981" : "#f59e0b",
        boxShadow: ok ? "0 0 6px #10b981" : "none",
    }),
};

export default function WatchdogPage() {
    const [activeTab, setActiveTab] = useState("setup");

    const renderTab = () => {
        switch (activeTab) {
            case "setup": return <WatchdogSetupTab />;
            case "dashboard": return <WatchdogDashboard />;
            default: return <WatchdogSetupTab />;
        }
    };

    return (
        <div style={s.page}>
            <div style={s.header}>
                <div>
                    <div style={s.headerTitle}>🐕 Watchdog</div>
                    <div style={s.headerSub}>Event-driven location mismatch detection · Validates only orders with webhook events</div>
                </div>
                <div style={s.dbStatus(true)}>
                    <span style={s.dot(true)} />
                    PostgreSQL Connected
                </div>
            </div>

            <div style={s.tabBar}>
                {tabs.map(t => (
                    <button key={t.key} style={s.tab(activeTab === t.key)} onClick={() => setActiveTab(t.key)}>
                        {t.label}
                    </button>
                ))}
            </div>

            <div style={s.content}>
                {renderTab()}
            </div>
        </div>
    );
}
